import ListViewColumn from '../../model/list-view-column';

export interface AllowSort {
  allowSort(column: ListViewColumn): boolean;
}

class NoSort implements AllowSort {
  allowSort(): boolean {
    return false;
  }
}

/** To disallow sort, use the constant 'AllowSort.No' */
export namespace AllowSort {
  export const No = new NoSort();
}
